import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { CModal } from '@coreui/react';
import ReactPlayer from 'react-player';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionUploadVideo = () => {
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const initialFormState = {
        url: '',
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        sectionLessonMasterId: '',
        sectionTopicMasterId: '',
        instituteSubjectMasterId: '',
        sectionSubTopicMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [showPdfLink, setShowPdfLink] = useState("")
    const [visible, setVisible] = useState(false)

    const [isFullScreen, setFullScreen] = useState(false);
    const playerRef = useRef(null);
    const [played, setPlayed] = useState(0);
    const [play, setPlay] = useState(false)
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subTopicNameSort, setSubTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "sectionLessonMasterDetails.sectionLessonName", "sectionTopicMasterDetails.sectionTopicName", "sectionSubTopicMasterDetails.sectionSubTopicName"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        getVideoList();
    }, [subtopicData.instituteSubjectMasterId, subtopicData.sectionLessonMasterId, subtopicData.sectionTopicMasterId, subtopicData.sectionSubTopicMasterId]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getVideoList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.sectionSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId !== '') {
                setSubtopicList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-section-text-book-upload-video?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (subtopicData.sectionSyllabusStructureMasterId) {
            apiUrl += `sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&`;
        }

        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`
        }

        if (subtopicData.sectionLessonMasterId) {
            apiUrl += `sectionLessonMasterId=${subtopicData.sectionLessonMasterId}&`;
        }

        if (subtopicData.sectionTopicMasterId) {
            apiUrl += `sectionTopicMasterId=${subtopicData.sectionTopicMasterId}&`;
        }

        if (subtopicData.sectionSubTopicMasterId) {
            apiUrl += `sectionSubTopicMasterId=${subtopicData.sectionSubTopicMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getVideoList();
    }, [subtopicData]);

    const getVideoList = async () => {
        if (subtopicData.sectionSyllabusStructureMasterId !== '' && subtopicData.instituteSubjectMasterId !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setSubtopicList(response.data.result);
            } catch (error) {
                setSubtopicList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                sectionSubTopicMasterId: '',
                sectionLessonMasterId: '',
                sectionTopicMasterId: ''
            }
        })

        const apiUrl = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionLessonMasterId: '',
                sectionTopicMasterId: '',
                sectionSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionTopicMasterId: '',
                sectionSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${subtopicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&sectionLessonMasterId=${subtopicData.sectionLessonMasterId}&sectionTopicMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                setSubTopicViewtopicList([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const isValidUrl = (url) => {
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        return urlRegex.test(url);
    };

    const validateForm = () => {
        const errorsValid = Object.values(error).every(error => error === '');

        // Check if every value in subtopicData is either a non-empty string or undefined
        const subtopicDataValid = Object.entries(subtopicData).every(([key, value]) => {
            // Exclude topicMasterId and subTopicMasterId from validation
            if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '' && key !== 'url') { // Skip validation for URL if it's empty
                        return false;
                    } else if (key === 'url' && value !== '' && !isValidUrl(value)) { // Validate URL
                        return false;
                    }
                }
            }
            return true;
        });

        return errorsValid && subtopicDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                // Exclude topicMasterId and subTopicMasterId from validation
                if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                    if (value === '' || value.length === 0 || (key === 'url' && !isValidUrl(value))) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: value === '' ? 'This field is required.' : 'Invalid URL'
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: ''
                        }));
                    }
                }
            }
        }
    }, [subtopicData]);

    const addVideo = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-text-book-upload-video`;
                const response = await authorizedAxiosSection.post(apiUrl, subtopicData);
                await getVideoList();
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        url: ''
                    }
                })
                setSaveId(response.data.result.id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSubTopicNameSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'sectionTopicMasterId' && key !== 'sectionSubTopicMasterId') {
                    if (value === '' || value.length === 0) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: 'This field is required.',
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: '',
                        }));
                    }
                }
            }

            // Check if URL is invalid
            if (subtopicData.url !== "" || subtopicData.url.length !== 0) {
                if (!isValidUrl(subtopicData.url)) {
                    setError(prevData => ({
                        ...prevData,
                        url: 'Invalid URL',
                    }));
                }
            }
        }
    }

    const deleteVideo = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-text-book-upload-video?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                await getVideoList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateVideo = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-section-text-book-upload-video?id=${editId}`;
            const response = await authorizedAxiosSection.put(apiUrl, subtopicData);
            await getVideoList();
            setEditId(null);
            setSaveId(response.data.result.id);
            setSubtopicData((prevData) => {
                return {
                    ...prevData,
                    url: ''
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setSubtopicData(initialFormState);
        setError(initialErrorState);
        setEditId('');
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubTopicViewtopicList([]);
        setSubtopicList([]);
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
            setSubTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setSubTopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subTopicNameSort == true || subTopicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [subTopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Video</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i>Upload Video</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleLessonChange} value={subtopicData.sectionLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionLessonMasterId && <p style={{ color: 'red' }}>{error.sectionLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionTopicMasterId' onChange={handleTopicChange} value={subtopicData.sectionTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionTopicMasterId && <p style={{ color: 'red' }}>{error.sectionTopicMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='sectionSubTopicMasterId' onChange={handleInputChange} value={subtopicData.sectionSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="url" value={subtopicData.url} onChange={handleInputChange} />
                                                    {error.url && <p style={{ color: 'red' }}>{error.url}</p>}
                                                </div>
                                            </div>

                                            <CModal
                                                backdrop="static"
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                                className={isFullScreen ? "full_scr_view" : ""}
                                            >
                                                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                                                <div className="test test-player">
                                                    <ReactPlayer
                                                        ref={playerRef}
                                                        url={showPdfLink}
                                                        playing={play}
                                                        volume={volume}
                                                        onProgress={handleProgress}
                                                        playbackRate={playbackRate}
                                                    >
                                                    </ReactPlayer>
                                                    <div className="overlay-layer">
                                                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                                                    </div>
                                                </div>
                                                <div className="video_content_bottom">
                                                    <div className="video_progress">
                                                        <input
                                                            type="range"
                                                            min={0}
                                                            max={1}
                                                            step="any"
                                                            value={played}
                                                            onChange={handleSeekChange}
                                                            className="input_slider"
                                                        />
                                                    </div>
                                                    <div className='play_pause_sound'>
                                                        <div className='sound'>
                                                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}
                                                            {volume >= 0.5 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-high"></i>
                                                            </button>}
                                                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-low"></i>
                                                            </button>}
                                                            {volume == 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-xmark"></i>
                                                            </button>}
                                                            <div className='sound_bar'>
                                                                <input
                                                                    type="range"
                                                                    value={volume}
                                                                    onChange={handleVolumeChange}
                                                                    min="0"
                                                                    max="1"
                                                                    step="0.01"
                                                                    className="input_slider"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='playbeack_speed'>
                                                            <span>Playback speed</span>
                                                            <select onClick={handleSpeedChange}>
                                                                <option value={0.25}>0.25</option>
                                                                <option value={0.5}>0.5</option>
                                                                <option value={0.75}>0.75</option>
                                                                <option selected value={1}>Normal</option>
                                                                <option value={1.25}>1.25</option>
                                                                <option value={1.5}>1.5</option>
                                                                <option value={1.75}>1.75</option>
                                                            </select>
                                                        </div>
                                                        {/* <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}> {isFullScreen ? <i class="fa fa-expand"></i> : <i class="fa fa-compress"></i>}</button>
                                                        </div> */}

                                                        <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addVideo}>Save</button>
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateVideo} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionLessonMasterDetails.sectionLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionTopicMasterDetails.sectionTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subTopicNameSort} setSortState={setSubTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"sectionSubTopicMasterDetails.sectionSubTopicName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Video
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.sectionSyllabusStructureMasterDetails?.sectionSyllabusStructureName}</td>
                                                                                        <td>{subtopic?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.sectionLessonMasterDetails?.sectionLessonName}</td>
                                                                                        <td>{subtopic?.sectionTopicMasterDetails?.sectionTopicName}</td>
                                                                                        <td>{subtopic?.sectionSubTopicMasterDetails?.sectionSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(subtopic?.url)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye"></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSubtopicData({
                                                                                                    url: subtopic?.url,
                                                                                                    sectionSyllabusStructureMasterId: subtopic?.sectionSyllabusStructureMasterId,
                                                                                                    sectionLessonMasterId: subtopic?.sectionLessonMasterId,
                                                                                                    sectionTopicMasterId: subtopic?.sectionTopicMasterId,
                                                                                                    instituteSubjectMasterId: subtopic?.instituteSubjectMasterId,
                                                                                                    sectionSubTopicMasterId: subtopic?.sectionSubTopicMasterId
                                                                                                });
                                                                                                setEditId(subtopic.id);
                                                                                                setTopicList([{
                                                                                                    id: subtopic.sectionTopicMasterId,
                                                                                                    sectionTopicName: subtopic.sectionTopicMasterDetails?.sectionTopicName
                                                                                                }]);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === subtopic.id} onClick={() => deleteVideo(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionUploadVideo;